import { ABILITY_ACTION, AvatarAbility, AvatarMode, AvatarRarity } from '@common/contracts';
export const avatarModes = [
    AvatarMode.Minimum,
    AvatarMode.Exclusive
];
export const avatarRarities = [
    AvatarRarity.Common,
    AvatarRarity.Rare,
    AvatarRarity.Epic,
    AvatarRarity.Legendary,
    AvatarRarity.Mythic
];
export const avatarModeNames = [
    'Min Rarity',
    'Exclusive'
];
export const avatarModeLabels = [
    'minimum',
    'exclusive'
];
export const avatarRarityLabels = [
    'common',
    'rare',
    'epic',
    'legendary',
    'mythic'
];
export const avatarRarityNames = [
    'Common',
    'Rare',
    'Epic',
    'Legendary',
    'Mythic'
];
// GuildType ordinal → the Order that grew the Avatar. Names as the game shows
// them (LocalizationStorage.cs), not the enum members: GreenShadows reads
// "Shadows", DefendersOfMesopotamia reads "Meso", NineTailedFox reads "Fox".
export const avatarOrderNames = {
    1: 'Round Table',
    2: 'Shadows',
    3: 'Ganga',
    4: 'Meso',
    5: 'Quetzal',
    6: 'Valhalla',
    7: 'Fox',
    8: 'Argonauts',
};
// ── Ability names ────────────────────────────────────────────────────────────
// One characteristic, one name: Psi-energy. That is what the game calls it on an
// Avatar (locale avatar.psi_energy / "Пси-энергия"), what its icon file is called
// (assets/challenges/Psi-Energy.webp), and what the enum member itself says
// (PerceptionOrPsiEnergy). The game's equipment-upgrade modal is the ONE screen
// that still renders it as "Perception" / "Восприятие"
// (equipment.equipment_ability_type.perception_or_psi_energy, used only by
// features/UpgradeEquipment) — a leftover, not a second concept, so the editor
// does not reproduce it.
//
// The stored enum value stays `Perception`; this is display only. The game also
// spells it "Defense", never "Defence" — the enum keeps the British spelling
// because that is what is written in the database.
export const abilityNames = {
    Strength: 'Strength',
    Perception: 'Psi-energy',
    Agility: 'Agility',
    Defence: 'Defense',
    Intellect: 'Intellect',
};
export const abilityName = (ability) => { var _a; return (_a = abilityNames[ability]) !== null && _a !== void 0 ? _a : ability; };
/** GameAbilityType order (0 Strength, 1 Psi-energy, 2 Agility, 3 Defence, 4 Intellect). */
export const ABILITY_BY_TYPE = ['Strength', 'Perception', 'Agility', 'Defence', 'Intellect'];
/**
 * The action an approach takes, as the game prints it under the ability.
 *
 * Levels generated before approaches carried an action stored the ABILITY NAME in
 * that field, so reading it back verbatim would print the characteristic twice.
 * An ability name therefore counts as "nothing authored", and the ability's own
 * verb stands in — the same fallback the generator uses.
 */
export function approachActionLabel(title, ability) {
    var _a;
    const authored = (title !== null && title !== void 0 ? title : '').trim();
    const isAbilityName = Object.values(AvatarAbility).includes(authored);
    if (authored && !isAbilityName)
        return authored;
    return (_a = ABILITY_ACTION[ability]) !== null && _a !== void 0 ? _a : '';
}
